import React, { useContext } from 'react';
import styled from 'styled-components';
import { device } from '../../providers/theme';
import { Link } from 'gatsby';
import { UserContext } from '../../providers/user';

const Container = styled.footer`
  margin-top: 12px;
  position: relative;
  padding: 32px 32px 84px;
  width: 100%;
  background: ${props => props.themeColor};
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  color: #fff;

  @media ${device.tablet} {
    padding: 22px 22px 64px;
  }
`;

const Login = styled(Link)``;

const FooterColumn = styled.div`
  flex: 1 0 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${props => (props.center ? 'center' : 'flex-start')};

  p {
    margin: 2px 0;
    font-weight: bold;
  }

  @media ${device.tablet} {
    flex: 1 0 50%;
    align-items: flex-start;
    padding: 22px;
  }

  @media ${device.mobile} {
    padding: 12px 0;
  }

  .active-footer-link {
    text-decoration: underline;
  }

  .footer-links {
    display: inline-block;
  }

  .footer-link {
    display: block;
    margin: 4px 0;
    padding: 12px 0;
  }
`;

function Footer({ themeColor }) {
  const { user } = useContext(UserContext);
  return (
    <Container themeColor={themeColor}>
      <FooterColumn>
        <h2>Kategori</h2>
        <div className="footer-links">
          <Link
            activeClassName="active-footer-link"
            className="footer-link"
            to="/roedvin"
          >
            Rødvin
          </Link>
          <Link
            activeClassName="active-footer-link"
            className="footer-link"
            to="/hvidvin"
          >
            Hvidvin
          </Link>
          <Link
            activeClassName="active-footer-link"
            className="footer-link"
            to="/rose"
          >
            Rosé
          </Link>
          <Link
            activeClassName="active-footer-link"
            className="footer-link"
            to="/champagne"
          >
            Champagne
          </Link>
          <Link
            activeClassName="active-footer-link"
            className="footer-link"
            to="/mousserende"
          >
            Mousserende vin
          </Link>
          <Link
            activeClassName="active-footer-link"
            className="footer-link"
            to="/portvin"
          >
            Portvin
          </Link>
          <Link
            activeClassName="active-footer-link"
            className="footer-link"
            to="/dessertvin"
          >
            Dessertvin
          </Link>
        </div>
      </FooterColumn>
      <FooterColumn>
        <h2>Vinkammeret</h2>
        <div className="footer-links">
          <Link
            activeClassName="active-footer-link"
            className="footer-link"
            to="/blog"
          >
            Blog
          </Link>
          <Link
            activeClassName="active-footer-link"
            className="footer-link"
            to="/om-os"
          >
            Om os
          </Link>
          <Link
            activeClassName="active-footer-link"
            className="footer-link"
            to="/kontakt"
          >
            Kontakt
          </Link>
          <Link
            activeClassName="active-footer-link"
            className="footer-link"
            to="/cookies"
          >
            Cookies
          </Link>
          <Link
            activeClassName="active-footer-link"
            className="footer-link"
            to="/sitemap.xml"
          >
            Sitemap
          </Link>
        </div>
      </FooterColumn>
      <FooterColumn center>
        <p>8000 Aarhus C</p>
        <p>jk@midear.dk</p>
        <p>
          Vi forhandler ikke selv vine, <br />
          men samarbejder med landets vinbutikker.
          <br /> Vi driver også{' '}
          <a href="https://charterferien.dk">Charterferien</a>
        </p>
      </FooterColumn>
    </Container>
  );
}

export default Footer;
